import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IsNotSaved from '../IsNotSaved';
import useUpdateState from '../hooks/useUpdateState';
import ProjectDetailRow from './ProjectDetailRow';
const listVersion7 = [{
  name: 'b1_sum_wages_own_employees_before',
  translationKey: 'b1_sum_wages_own_employees_before'
}, {
  name: 'less_expenditure_other_funding_claimed_before_2020',
  translationKey: 'less_expenditure_other_funding_claimed_before_2020'
}, {
  name: 'calc_eligible_expenses_wages_own_employees_1_version_7',
  translationKey: 'calc_eligible_expenses_wages_own_employees_1_version_7'
}, {
  name: 'd1_sum_wages_own_employees_after',
  translationKey: 'd1_sum_wages_own_employees_after'
}, {
  name: 'less_expenditure_other_funding_claimed_after_2020',
  translationKey: 'less_expenditure_other_funding_claimed_after_2020'
}, {
  name: 'calc_eligible_expenses_wages_own_employees_2_version_7',
  translationKey: 'calc_eligible_expenses_wages_own_employees_2_version_7'
}];
const calculationsVersion7 = ['b1_sum_wages_own_employees_before', 'calc_eligible_expenses_wages_own_employees_1_version_7', 'd1_sum_wages_own_employees_after', 'calc_eligible_expenses_wages_own_employees_2_version_7'];
const listVersion8 = [{
  name: 'b1_sum_wages_own_employees_before',
  translationKey: 'b1_sum_wages_own_employees_before'
}, {
  name: 'less_expenditure_other_funding_claimed_before_2024',
  translationKey: 'less_expenditure_other_funding_claimed_before_2024'
}, {
  name: 'calc_eligible_expenses_wages_own_employees_1_version_8',
  translationKey: 'calc_eligible_expenses_wages_own_employees_1_version_8'
}, {
  name: 'd1_sum_wages_own_employees_after',
  translationKey: 'd1_sum_wages_own_employees_after'
}, {
  name: 'less_expenditure_other_funding_claimed_after_2024',
  translationKey: 'less_expenditure_other_funding_claimed_after_2024'
}, {
  name: 'calc_eligible_expenses_wages_own_employees_2_version_8',
  translationKey: 'calc_eligible_expenses_wages_own_employees_2_version_8'
}];
const calculationsVersion8 = ['b1_sum_wages_own_employees_before', 'calc_eligible_expenses_wages_own_employees_1_version_8', 'd1_sum_wages_own_employees_after', 'calc_eligible_expenses_wages_own_employees_2_version_8'];
const EligibleExpenditure = _ref => {
  let {
    projectDetails,
    setProjectDetails,
    updateProjectDetails,
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [updateState] = useUpdateState(setProjectDetails, setIsNotSaved);
  const saveData = async body => {
    await updateProjectDetails(body);
    setIsNotSaved(false);
  };
  if (!projectDetails) return /*#__PURE__*/React.createElement("div", null, t('loading...'));
  const isVersion8 = (elster === null || elster === void 0 ? void 0 : elster.version_number) === 'version_8';
  const list = isVersion8 ? listVersion8 : listVersion7;
  const calculations = isVersion8 ? calculationsVersion8 : calculationsVersion7;
  const projectRows = list.map((field, index) => {
    if (calculations.includes(field.name)) {
      return /*#__PURE__*/React.createElement(ProjectDetailRow, {
        rowData: [field.name, projectDetails.calculations[field.name]],
        translationKey: field.translationKey,
        index: index,
        updateState: updateState,
        projectDetails: projectDetails,
        key: field.name + 'rowData',
        disabled: true,
        isVersion8: isVersion8
      });
    }
    return /*#__PURE__*/React.createElement(ProjectDetailRow, {
      rowData: [field.name, projectDetails[field.name]],
      translationKey: field.translationKey,
      index: index,
      updateState: updateState,
      projectDetails: projectDetails,
      key: field.name + 'rowData',
      isVersion8: isVersion8
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, projectRows, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [projectDetails]
  }));
};
export default EligibleExpenditure;